module.exports = __webpack_public_path__ + "static/media/p208motor2.8169a709.jpg";